import gql from 'graphql-tag'

export default gql`
  mutation course_homeworks_create_mutation(
    $description: String!
    $files: [CourseAssetFileCreateInput!]
    $finishedUrl: String
    $briefUrl: String
    $image: Upload!
    $links: [CourseAssetLinkCreateInput!]
    $slug: String!
    $title: String!
    $isRequired: Boolean!
  ) {
    courseHomeworkCreate(
      description: $description
      files: $files
      finishedUrl: $finishedUrl
      briefUrl: $briefUrl
      image: $image
      links: $links
      slug: $slug
      title: $title
      isRequired: $isRequired
    ) {
      id
    }
  }
`
